export default {

    matchStartingSubString(str1, str2) {
        for(var i=0; i<str1.length; i++)
            if(str1[i]!== str2[i]) break
          
        return (i> 5 && str1.substring(0, i).includes('Child')  && str2.substring(0, i).includes('Child'))
    }

}